import {registerNav} from '../../components/common/di-ding'
import {routeNameOfDi} from './common'

const nav = [
  {
    icon: 'el-icon-damai-menjinquanxianfenpei',
    name: '基本配置',
    permissionCode: '005001000',
    to: {
      routeName: 'electronic-config',
      also: {
        routeName: ['modify-electronic-config']
      }
    }
  },
  {
    icon: 'el-icon-damai-shujudaoru',
    name: '数据导入',
    permissionCode: '005002000',
    to: {
      diName: routeNameOfDi.ELECTRONIC_IMPORT
    }
  },
  {
    icon: 'el-icon-damai-dianbiaoliebiao',
    name: '缴费记录',
    permissionCode: '005003000',
    to: {
      diName: routeNameOfDi.ELECTRONIC_RECORD
    }
  },
  // {
  //   icon: 'el-icon-damai-ic_caozuorizhi',
  //   name: '操作日志',
  //   permissionCode: '005004000',
  //   to: {
  //     routeName: 'electronic-control-log'
  //   }
  // }
  // {
  //   icon: 'el-icon-damai-zhinengdianbiao',
  //   name: '电费统计',
  //   to: {
  //     routeName: 'electronic-statistics',
  //   }
  // }
]

registerNav(nav)



// WEBPACK FOOTER //
// ./src/view/ElectronicControl/nav.js